// components/qualificacao/AvisoDesfazer.js — "Marcado como X. Desfazer"
// (out/26, rastreamento PR 2). Fica onde a marcação foi feita (janela do
// contato, topo do chat) pelos 10 s do `useQualificar`.

import { Box } from '@mui/material';
import { FiCheck, FiX } from 'react-icons/fi';

const FONTE = "'Outfit', system-ui, sans-serif";
const foco = { '&:focus-visible': { outline: '2px solid var(--ch-green)', outlineOffset: 2 } };

export default function AvisoDesfazer({ aviso, erro, onDesfazer, onFechar, compacto = false }) {
  if (!aviso && !erro) return null;
  return (
    <Box role={erro ? 'alert' : 'status'} sx={{
      display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0,
      p: compacto ? '4px 4px 4px 10px' : '8px 8px 8px 12px', borderRadius: '10px', fontFamily: FONTE,
      fontSize: compacto ? 12.5 : 13.5, bgcolor: erro ? 'var(--ch-red-bg)' : 'var(--ch-green-bg)',
      color: erro ? 'var(--ch-red-d)' : 'var(--ch-green-d)', border: `1px solid ${erro ? 'var(--ch-red-b)' : 'var(--ch-green-b)'}`,
    }}>
      {!erro && <FiCheck size={14} aria-hidden style={{ flexShrink: 0 }} />}
      <Box component="span" sx={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: compacto ? 'nowrap' : 'normal' }}>
        {erro || aviso?.texto}
      </Box>
      {!erro && (
        <Box component="button" type="button" onClick={onDesfazer} sx={{
          ...foco, flexShrink: 0, height: 26, px: '10px', border: 0, borderRadius: '8px', cursor: 'pointer',
          bgcolor: 'transparent', color: 'inherit', fontFamily: FONTE, fontSize: 'inherit', fontWeight: 700,
          textDecoration: 'underline', textUnderlineOffset: 3, '&:hover': { bgcolor: 'rgba(127,127,127,.12)' },
        }}>
          Desfazer
        </Box>
      )}
      <Box component="button" type="button" onClick={onFechar} aria-label="Fechar aviso" sx={{
        ...foco, flexShrink: 0, width: 24, height: 24, p: 0, border: 0, borderRadius: '999px', cursor: 'pointer',
        bgcolor: 'transparent', color: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <FiX size={12} strokeWidth={2.4} />
      </Box>
    </Box>
  );
}
